import { metricLabel } from '../helpers'
import type { FilterState } from '../types'

export function filterDiffLines(current: FilterState, prior: FilterState | undefined): string[] {
  if (!prior) return []
  const lines: string[] = []
  const pairs: Array<[keyof FilterState, string]> = [
    ['metric', 'Metric'],
    ['stage', 'Stage'],
    ['assetClass', 'Asset class'],
    ['assignee', 'Assignee'],
    ['year', 'Year'],
    ['search', 'Search'],
  ]
  for (const [key, label] of pairs) {
    const left = String(prior[key] ?? '')
    const right = String(current[key] ?? '')
    if (left !== right) {
      const from = key === 'metric' ? metricLabel(prior.metric) : left || '(empty)'
      const to = key === 'metric' ? metricLabel(current.metric) : right || '(empty)'
      lines.push(`${label}: ${from} → ${to}`)
    }
  }
  if (JSON.stringify(current.report ?? null) !== JSON.stringify(prior.report ?? null)) {
    lines.push('Report design (filters / style / totals / paper) updated')
  }
  return lines
}
